/** Cible de navigation au clic sur une notification (cloche). */

export type NotificationLike = {
  metadata: Record<string, unknown> | null;
};



const stringMeta = (m: Record<string, unknown>, key: string): string | undefined => {
  const v = m[key];
  return typeof v === "string" && v.length > 0 ? v : undefined;
}



export const getProNotificationPath = (notif: NotificationLike): string | null => {
  const m = notif.metadata;
  if (!m) return null;

  const appointmentId = stringMeta(m, "appointmentId");
  if (appointmentId) {
    return `/calendar?appointmentId=${encodeURIComponent(appointmentId)}`;
  }

  const clientId = stringMeta(m, "clientId");
  if (clientId && stringMeta(m, "invoiceId")) {
    return `/clients/${encodeURIComponent(clientId)}`;
  }

  if (stringMeta(m, "programAssignmentId")) {
    return "/programs";
  }

  const requestId = stringMeta(m, "requestId");
  if (requestId && clientId) {
    return `/clients/${encodeURIComponent(clientId)}`;
  }

  return null;
}
